export const waveform_array: number[] = [
  54, 57, 58, 8, 25, 63, 74, 65, 4, 53, 3, 57, 80, 80, 14, 58, 25, 80, 39, 65,
  20, 62, 60, 1, 78, 43, 49, 67, 26, 41, 76, 7, 73, 1, 39, 35, 66, 5, 52, 23,
  25, 51, 40, 2, 16, 67, 40, 73, 7, 16, 53, 57, 18, 78, 47, 13, 32, 23, 31, 35,
  48, 30, 43, 7, 3, 61, 55, 24, 49, 70, 28, 17, 16, 49, 67, 25, 46, 77, 71, 60,
  31, 23, 25, 46, 29, 42, 58, 11, 61, 12, 21, 73, 4, 9, 22, 10, 33, 71, 28, 46,
  70, 40, 7, 21, 69, 33, 14, 7, 12, 33, 15, 40, 49, 12, 29, 17, 46, 4, 3, 79,
  49, 7, 75, 70, 1, 74, 30, 70, 56, 41, 40, 32, 49, 15, 23, 62, 70, 24, 61, 16,
  61, 7, 15, 2, 17, 44, 26, 65, 25, 63, 18, 56, 77, 47, 6, 45, 50, 1, 73, 2, 31,
  39, 40, 69, 60, 21, 2, 41, 10, 48, 26, 27, 26, 74, 11, 8, 50, 56, 1, 17
];

export const waveform_is_bought: boolean[] = [
  false,
  true,
  false,
  true,
  true,
  true,
  true,
  false,
  true,
  true,
  true,
  false,
  false,
  false,
  false,
  true,
  true,
  false,
  true,
  false,
  false,
  false,
  false,
  false,
  true,
  false,
  false,
  false,
  true,
  false,
  true,
  false,
  false,
  false,
  false,
  true,
  true,
  true,
  true,
  true,
  true,
  false,
  true,
  false,
  false,
  false,
  true,
  true,
  true,
  true,
  false,
  true,
  false,
  true,
  true,
  false,
  false,
  true,
  false,
  false,
  true,
  false,
  true,
  false,
  false,
  false,
  true,
  false,
  true,
  true,
  true,
  true,
  true,
  true,
  true,
  false,
  true,
  false,
  true,
  false,
  false,
  false,
  true,
  true,
  false,
  false,
  false,
  false,
  true,
  true,
  false,
  false,
  true,
  true,
  false,
  true,
  false,
  false,
  true,
  true,
  false,
  false,
  false,
  true,
  true,
  true,
  false,
  true,
  true,
  false,
  false,
  true,
  false,
  true,
  false,
  true,
  false,
  false,
  true,
  true,
  true,
  false,
  false,
  true,
  true,
  false,
  false,
  true,
  false,
  false,
  true,
  false,
  true,
  true,
  true,
  true,
  true,
  false,
  true,
  false,
  false,
  false,
  true,
  false,
  false,
  false,
  false,
  true,
  false,
  false,
  false,
  true,
  true,
  false,
  true,
  false,
  false,
  true,
  false,
  false,
  false,
  true,
  true,
  true,
  false,
  false,
  true,
  false,
  true,
  true,
  false,
  false,
  true,
  false,
  false,
  true,
  true,
  false,
  false,
  true
];
